import React from 'react';

export default function IndexSectionCallToAction10() {
    return (
        <React.Fragment>
            <>
                <section id={'feature-query'} className="py-20 bg-green-500 bg-no-repeat bg-cover bg-center"
                         style={{backgroundImage: 'url("cronos-assets/elements/lines3.svg")'}}>
                    <div className="container mx-auto px-4">
                        <div className="flex justify-center mb-6">
                            <div className="bg-green-400 py-1 px-2 text-xs text-white font-bold inline-block">New
                                feature
                            </div>
                        </div>
                        <h1 className="font-heading text-white text-center text-4xl lg:text-5xl font-bold max-w-2xl lg:max-w-5xl mx-auto mb-4">Make
                            any type of query and we'll suggest something for you</h1>
                        <p className="text-green-100 text-center max-w-xl mx-auto mb-6">FindAMeal uses AI to interpret
                            your search, which means that you can query for anything you’d like, from ‘find me the best
                            date spot around’ to ‘pick a fancy restaurant for my birthday which serves steak’, we got
                            you covered.</p>
                        <div className="flex flex-wrap justify-center gap-4">
                            <a className="px-6 py-3 block text-center w-full sm:w-auto bg-orange-900 text-white text-sm font-bold hover:bg-orange-800 focus:ring focus:ring-orange-700 transition duration-200"
                               href="#">Share with friends</a>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}

